<template>
  <section>
    <el-col
      v-if="buttonList != null && buttonList.length > 0"
      :span="24"
      class="toolbar"
      style="padding-bottom: 0px"
    >
      <el-form :inline="true" @submit.native.prevent :model="filters">
        <el-form-item>
          <el-input
            v-model="filters.Name"
            placeholder="姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="filters.CompanyName"
            placeholder="任职企业"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="filters.PhoneNumber"
            placeholder="手机 "
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item v-for="item in buttonList" v-bind:key="item.id">
          <el-button
            :type="
              item.Func &&
              (item.Func.toLowerCase().indexOf('handledel') != -1 ||
                item.Func.toLowerCase().indexOf('stop') != -1)
                ? 'danger'
                : 'primary'
            "
            v-if="!item.IsHide"
            @click="callFunc(item)"
            >{{ item.name }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table
      :data="tabData"
      border=""
      v-loading="listLoading"
      @select="dialogCheck"
      @row-click="selectCurrentRow"
      ref="table"
      style="width: 100%"
      class="custom-tbl"
    >
      <!-- <el-table-column type="selection" width="50"></el-table-column> -->
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column
        prop="TopicName"
        label="课题名称"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="Name" label="姓名" width="100"></el-table-column>
      <el-table-column
        prop="CompanyName"
        label="公司名称"
        width="200"
      ></el-table-column>
      <el-table-column prop="Position" label="职位" width="100">
      </el-table-column>
      <el-table-column
        prop="PhoneNumber"
        label="手机"
        width="120"
      ></el-table-column>
      <el-table-column prop="Email" label="邮箱" width="180"></el-table-column>
      <el-table-column
        prop="Type"
        label="申报课题类别"
        width="200"
      ></el-table-column>
      <el-table-column
        prop="Desc"
        label="课题研究内容概述"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="filters.PageIndex"
        :page-size="filters.PageSize"
        :total="filters.total"
        style="float: right"
      ></el-pagination>
    </el-col>
  </section>
</template>

<script>
import { getTopicCollectionPageList } from '../../api/api'
import { getButtonList } from '../../promissionRouter'

export default {
  data() {
    return {
      listLoading: false,
      buttonList: [],
      addFormVisible: false, // 新增弹框
      filters: {
        Name: '',
        CompanyName: '',
        PhoneNumber: '',
        PageIndex: 1, //第几页
        PageSize: 20, // 每页多少条
        total: 0, // 总记录
        pageCount: 1,
      },
      tabData: [], // 列表绑定数据
      loadingActivityName: false, // 适用活动 加载效果
    }
  },
  components: {
    // Toolbar
  },
  methods: {
    // 翻页事件
    handleSizeChange(pageSize) {
      this.filters.PageSize = pageSize
      this.handleQuery()
    },
    // 翻页事件
    handleCurrentChange(currentPage) {
      this.filters.PageIndex = currentPage
      this.handleQuery()
    },

    // 按钮点击事件传值
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    dialogCheck(selection, row) {
      this.currentRow = null
      this.$refs.table.clearSelection()
      if (selection.length === 0) {
        return
      }
      if (row) {
        this.selectCurrentRow(row)
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val
        this.$refs.table.clearSelection()
        this.$refs.table.toggleRowSelection(val, true)
      }
    },
    handleCurrentChange(val) {
      this.filters.PageIndex = val
      this.handleQuery()
    },
    // 查询按钮——显示数据
    handleQuery() {
      this.listLoading = true
      getTopicCollectionPageList(this.filters).then((res) => {
        if (res.data.success) {
          this.filters.total = res.data.response.dataCount
          this.filters.pageCount = res.data.response.pageCount
          this.tabData = res.data.response.data
          this.listLoading = false
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
    handleExport() {
      const token = window.localStorage.getItem('Token')
      const url = `${process.env.VUE_APP_BASE_API}/api/DataCollection/topic/export`
      var xhr = new XMLHttpRequest()
      var params = JSON.stringify(this.filters)
      xhr.open('post', url, true)
      xhr.responseType = 'blob' // 返回类型blob
      xhr.setRequestHeader('Authorization', 'Bearer ' + token) // 携带token校验
      xhr.setRequestHeader('Content-type', 'application/json')
      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response
          var reader = new FileReader()
          reader.readAsDataURL(blob) // 转换为base64
          reader.onload = function (e) {
            var a = document.createElement('a') // 创建一个a标签用于下载
            a.download = '数据收集.xls' //文件名
            a.href = e.target.result
            a.click()
            $(a).remove()
          }
        }
      }
      xhr.send(params) // 发送ajax请求
    },
  },
  mounted() {
    this.handleQuery()
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : []
    this.buttonList = getButtonList(this.$route.path, routers)
  },
}
</script>
<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
